<template>
  <li :class="'b-aside__nav-item' + (routerName(nav.linkName) ? ' nav-item--active' : '')">
    <router-link
      tag="a"
      :data-cy="nav.linkName"
      class="b-aside__nav-link"
      :to="{ name: nav.linkName }"
      exact>
      <div class="b-aside__nav-link-inner">
        <dynamic-icon class="b-aside__nav-icon" :icon="nav.icon" />
        <div class="b-aside__nav-link-name">{{ nav.name }}</div>
      </div>
    </router-link>
  </li>
</template>
<script>
export default {
  name: "aside-item-component",
  props: ["nav"],
  methods: {
    routerName(name) {
      if (this.$route.matched[0]) {
      	if(name === 'Counterparty' && this.$route.matched[0].name === 'Directories') {
      		return true;
        }
        return this.$route.matched[0].name === name;
      }
    }
  }
};
</script>
